import { Link } from "react-router-dom";
import { useLogout } from "../auth/hooks";
import { PageHeader } from "../../components/PageHeader";
import { LogOutIcon, PackageIcon, SettingsIcon, TagIcon, ChevronRightIcon, RulerIcon, CreditCardIcon, ReceiptIcon, ConsignmentIcon } from "../../components/icons";

const links = [
  { to: "/admin/products", label: "Productos", description: "Catálogo, estados y categorías", icon: PackageIcon },
  { to: "/admin/categories", label: "Categorías", description: "Organización del catálogo", icon: TagIcon },
  { to: "/admin/size-guides", label: "Guías de talles", description: "Opciones y asociaciones por producto", icon: RulerIcon },
  { to: "/admin/payment-methods", label: "Medios de pago", description: "Descuentos, orden y comportamiento", icon: CreditCardIcon },
  { to: "/liquidaciones", label: "Liquidaciones", description: "Cobros por liquidación (ej. ClubCred)", icon: ReceiptIcon },
  { to: "/consignaciones", label: "Consignaciones", description: "Prendas entregadas y saldos pendientes", icon: ConsignmentIcon },
  { to: "/admin/operators", label: "Administración", description: "Operadores y accesos", icon: SettingsIcon },
] as const;

export function MoreView() {
  const logout = useLogout();
  return (
    <main className="page page--narrow">
      <PageHeader title="Más" />
      <section className="page-section">
        <p className="eyebrow">Gestión</p>
        <div className="settings-list">
          {links.map(({ to, label, description, icon: Icon }) => (
            <Link key={to} to={to} className="settings-row">
              <span className="settings-row__icon"><Icon width={20} height={20} /></span>
              <span><strong>{label}</strong><small>{description}</small></span>
              <ChevronRightIcon />
            </Link>
          ))}
        </div>
      </section>
      <section className="page-section">
        <button className="logout-row" type="button" onClick={() => logout.mutate()} disabled={logout.isPending}>
          <LogOutIcon width={19} height={19} />
          {logout.isPending ? "Saliendo…" : "Cerrar sesión"}
        </button>
      </section>
    </main>
  );
}
